import store from '@/store';
import doRequest from '@/api/dssRequest';
import UserObject from '@/objects/UserObject';
import { getSubtotalPrice, getTotalDiscount } from '@/objects/Order';

export default class ShoppingCart {
  /**
   * Order all suggested products from an event
   * @param {String|Number} eventId
   * @returns {Promise} Return Promise
   */
  static orderSuggestedProducts(eventId) {
    const payload = {
      EventId: eventId,
      Reservations: {},
    };

    const reservations = store.getters['shoppingCart/orders'];

    if (reservations != null) {
      reservations.forEach((reservation) => {
        if (payload.Reservations[reservation.EventId] == null) {
          payload.Reservations[reservation.EventId] = [];
        }

        payload.Reservations[reservation.EventId].push(reservation.OrderId);
      });
    }

    return new Promise((resolve, reject) => {
      doRequest(
        resolve,
        reject,
        'orderSuggestedProducts',
        UserObject.getUserObjectId(),
        payload
      );
    });
  }

  /**
   * Handle the response of [orderSuggestedProducts]
   * @param {DssResponse} response DssResponse from [orderSuggestedProducts]
   */
  static onOrderSuggestedProductsResponse(response) {
    response.data.UpdatedReservations.forEach((reservation) => {
      if (
        reservation.MainOrder.Type !== 'Delivery' ||
        reservation.MainOrder.Type !== 'PickUp' ||
        reservation.MainOrder.Type !== 'Shiplee'
      ) {
        const order = {
          Date: new Date(),
          EventId: reservation.EventInfo.EventId,
          OrderId: reservation.MainOrder.OrderId,
          OrderTotalPrice: reservation.MainOrder.OrderTotalPrice,
          PriceCategories: {},
          Products: reservation.MainOrder.Products,
          ShoppingCartType: 'Product',
        };

        store.commit('shoppingCart/addOrderWithoutReservation', order);
      }
    });
  }

  /**
   * Get the subtotal price of all orders
   * @param {array} orders A list of order
   * @returns subtotal price of all orders
   */
  static getSubtotalPrice(orders) {
    let price = 0.0;
    orders.forEach((order) => {
      price += getSubtotalPrice(order);
    });
    return price;
  }

  static getTotalDiscount(orders) {
    let price = 0.0;
    orders.forEach((order) => {
      price += getTotalDiscount(order);
    });

    if (price < 0 && price > -0.01) {
      // Solve the precision issue
      price = 0;
    }

    return price;
  }

  static getTotalVatPrice(orders) {
    let price = 0.0;
    orders.forEach((order) => {
      price += order.OrderTotalPriceVat;
    });
    return price;
  }

  static getTotalPrice(orders) {
    let price = 0.0;
    orders.forEach((order) => {
      price += order.OrderTotalPrice;
    });
    return price;
  }
}
